<template>
    <!-- TODO css -->
    <modal @close="close">
      <div v-if="screen === 'form'">
        <h3 v-if="type === 'create' && platform === 'gifting'">Select & Send</h3>
        <h3 v-else-if="type === 'create' && platform === 'marketplace'">Marketplace Direct Send</h3>
        <h3 v-else-if="type === 'edit' && canEdit">Edit Gift Registration</h3>
        <h3 v-else-if="type === 'edit' && !canEdit">View Gift Registration</h3>
        <form @submit.prevent class="large-form">
            
            <!-- Gift Registration Starting Screen -->
            <div class="form-step step-start" v-if="step === 'start' || type === 'edit'">
                <h4 v-if="type==='create'"><b>Step 1:</b> Gift Choice and Recipient</h4>
                <div class="form-line" v-if="platform==='gifting' || item.type==='voucher'">
                    <div class="form-field" style="width: 70%">
                        <label>Gift Option *</label>
                        <select v-if="canEditPricing && platform==='gifting'" v-model="item.option_id" @change="onOptionChange" required>
                            <option value="null" v-if="type === 'create' || !item.option_id">- Choose -</option>
                            <option v-for="o in campaign.options" :value="o.id" v-if="o.enabled">{{ o.name }}</option>
                            <option v-for="o in campaign.options" :value="o.id" v-if="o.enabled == false" disabled>{{ o.name }} (N/A)</option>
                        </select>
                        <div v-else-if="platform==='gifting'" class="form-static-field">{{ optionName(item.option_id,campaign.options) }}</div>
                        <div v-else class="form-static-field">{{ option.name?option.name:item.voucher_brand_name }}</div>
                    </div>
                    <div class="form-field" v-if="item.type=='physical'" style="width: 30%">
                        <label>Quantity *</label>
                        <input v-if="canEditPricing" v-model="item.quantity" required>
                        <div v-else class="form-static-field">{{ item.quantity }}</div>
                    </div>
                    <div class="form-field" v-if="item.type=='voucher'" style="width: 30%">
                        <label>Value (£) *</label>
                        <select v-if="canEditPricing && voucherDenominations.length" v-model="item.voucher_value">
                            <option v-for="val in voucherDenominations" :value="parseFloat(val)">{{ val | toCurrency }}</option>
                        </select>
                        <input type="number" v-else-if="canEdit && canEditPricing" v-model="item.voucher_value" :min="voucherLimits.lower" :max="voucherLimits.upper" :step="voucherLimits.minor_unit" >
                        <div v-else class="form-static-field">{{ item.voucher_value | toCurrency }}</div>
                    </div>
                </div>
                                 
                <div v-if="option && option.name" class="form-line gift-registration-option-summary">
                    <div class="option-summary-left">
                        <img v-if="option.image_url" class="option-summary-image" :class="item.type=='voucher'?'voucher':''" :src="option.image_url">
                    </div>
                    <div class="option-summary-right">
                        <h3>{{ option.name }}</h3>
                        <!--<div v-if="option.price" class="pricing large">Gift value: <b>{{ option.price | toCurrency }}</b></div>     -->                   
                        <div v-if="item.type=='voucher' && canEdit" class="pricing">
                            <div v-if="voucherDenominations.length">This brand requires choosing a specific voucher value.</div>
                            <div v-else>
                                <div>Minimum value: <b>{{ voucherLimits.lower | toCurrency }}</b></div>
                                <div>Maximum value: <b>{{ voucherLimits.upper | toCurrency }}</b></div>
                                <div>Minor unit: <b>{{ voucherLimits.minor_unit | toCurrency }}</b></div>
                            </div>
                        </div>
                    </div>
                </div>   
                
                <div class="form-line">
                    <div class="form-field" style="width: 50%">
                        <label>First Name *</label>
                        <input v-if="canEdit && canEditAddress" v-model="item.first_name" required>
                        <div v-else class="form-static-field">{{ item.first_name }}</div>
                    </div>
                    <div class="form-field" style="width: 50%">
                        <label>Last Name *</label>
                        <input v-if="canEdit && canEditAddress" v-model="item.last_name" required>
                        <div v-else class="form-static-field">{{ item.last_name }}</div>
                    </div>
                </div>             
                
                <div class="form-line">
                    <div class="form-field">
                        <label>Recipient Email *</label>
                        <input v-if="canEdit && canEditAddress" v-model="item.email" required>
                        <div v-else class="form-static-field">{{ item.email }}</div>
                    </div>
                </div>
                
                <div class="form-line" v-if="type === 'create'">
                  <div class="form-field form-field-radio" v-if="item.type=='physical'" >
                      <label>Inform the recipient</label>
                      <div class="radio-option">
                        <input v-model="item.send_email" type="radio" value="false">
                        <span class="radio-label">No, do not send order updates to the recipient</span>
                      </div>
                      <div class="radio-option">
                        <input v-model="item.send_email" type="radio" value="true">
                        <span class="radio-label">Yes, send summary and tracking emails to the recipient</span>
                      </div>
                  </div>
                  
                  <div class="form-field form-field-checkbox" v-if="item.type=='voucher' || item.send_email==true || item.send_email=='true'" >
                      <label>Custom Email Text</label>
                      <div class="checkbox-option">
                        <input v-model="item.custom_email_message" type="checkbox">
                        <span class="checkbox-label">Add custom text to info email.</span>
                      </div>  
                      <textarea v-if="item.send_email && item.custom_email_message" v-model="item.invitation_message" placeholder="Write your custom email info message here." rows="6" maxlength="1015"></textarea>
                  </div>
                </div>
                
                <div class="form-line" v-if="item.type == 'voucher' && item.voucher_url">
                  <div class="form-field">
                      <label>Digital Gift Card Link</label>
                      <div class="form-static-field"><a :href="item.voucher_url" style="font-size: 13px; line-height: 1.5em !important; display: block; margin-bottom: 20px;" target="_blank">{{ item.voucher_url }}</a></div>
                  </div>
                </div>
                
                <div class="form-line" v-if="item.type == 'voucher' && type=='create'">
                    <div class="form-field">
                        <div class="small-note warning"><span>NOTE:</span> When using Direct Send to send a Gift Card Voucher, you are charged the voucher value immediately. The voucher code is generated and you will get access to it straight away. <b>This action can not be reverted.</b></div>
                        
                        <div class="small-note" v-if="platform === 'gifting'"><span>PRO TIP:</span> If you are collecting leads, or if you aren't sure if your recipient will claim the voucher, it is better to <a href="#" @click.prevent="modals.giftRegistrationModal = false; modals.giftInviteModal = true">Create A New Invitation</a> instead so the voucher is generated and you are charged only when your recipient claims it.</div>
                    </div>
                </div>
            </div>
            
            <!-- Address -->
            <div class="form-step step-address" v-if="step === 'address' || type === 'edit'">   
                <h4 v-if="type==='create'"><b>Step 2:</b> Delivery Address</h4>       
                <div class="form-line" v-if="item.type=='physical' && canEdit && canEditAddress">
                    <div class="form-field">
                        <label>Address Line 1 *</label>
                        <input v-model="item.address_line_1" required>
                    </div>
                </div>
                <div class="form-line" v-if="item.type=='physical' && canEdit && canEditAddress">
                    <div class="form-field">
                        <label>Address Line 2</label>
                        <input v-model="item.address_line_2">
                    </div>
                </div>
                <div class="form-line" v-if="item.type=='physical' && canEdit && canEditAddress"  >
                    <div class="form-field" style="width: 70%">
                        <label>City *</label>
                        <input v-model="item.city" required>
                    </div>
                    <div class="form-field" style="width: 30%">
                        <label>Postcode *</label>
                        <input v-model="item.postcode" required>
                    </div>                    
                </div>
                
                <div class="form-line" v-if="item.type=='physical' && canEdit && canEditAddress">
                    <div class="form-field">
                        <label>County / Region</label>
                        <input v-model="item.region">
                    </div>
                </div>
                
                <div class="form-line" v-if="item.type=='physical'">
                    <div class="form-field" v-if="canEditAddress && canEditPricing">
                        <label>Country *</label>
                        <select v-model="item.country" required>
                            <option v-for="c in shippingCountries" :value="c.value">{{ c.text }}</option>
                        </select>
                        <div class="form-field-desc" style="margin-top: 5px; text-align: right"><a class="ws-button small" style="margin-right: 0" href="/wp-content/plugins/worksends/files/worksends-shipping.pdf" download>Shipping Costs & Timeframes</a></div>
                    </div>
                    <div v-else class="form-field">
                        <label>Country *</label>
                        <div class="form-static-field">{{ countryName(item.country) }}</div>
                    </div>
                    
                </div>
                <div class="form-line" v-if="item.type=='physical' && canEdit && canEditAddress && item.country && item.country !== 'GB'">
                    <div class="form-field">
                        <label>Phone *</label>
                        <input v-model="item.phone" required>
                    </div>
                </div>
                
                           
            </div>
            
            <!-- Notecard -->
            <div class="form-step step-notecard" v-if="step === 'notecard' || type === 'edit'"> 
                <h4 v-if="type==='create'"><b>Step 3:</b> Attach a Greeting Card</h4> 
                <field-notecard v-if="item.type=='physical' && canEdit && canEditPricing" :item="item" :campaign="campaign" :option="option" :form-type="type"></field-notecard>
            </div>
            
            <!-- Summary & Payment -->
            <div class="form-step step-summary" v-if="step === 'summary' || type === 'edit'">  
                <h4 v-if="type==='create'"><b>Last Step:</b> Summary & Payment</h4> 
                
                <div class="form-line">
                    <div class="form-field">
                        <label>Price Breakdown</label>
                        <payment-summary-table :prices="prices" :prices-ex-vat="pricesExVat" :item="item" :platform="platform" :type="type"></payment-summary-table>
                    </div>
                    <div class="form-field">
                        <div class="small-note" v-if="!canEdit && rejected"><span>NOTE:</span> This order has already been rejected so it can not be edited anymore.</div>
                        <div class="small-note" v-else-if="!canEdit"><span>NOTE:</span> This order has already been processed or sent, so you can't edit it directly. If you require any changes, contact your <i>Bookblock HUB Account Manager</i>.</div>
                        <div class="small-note" v-else-if="!canEditAddress"><span>NOTE:</span> You can only view and change adress of the giftee's that you registered via Select & Send. To update personal details of this giftee, please contact your <i>Bookblock HUB Account Manager</i>.</div>
                    </div>
                </div>
                
                <field-payment :item="item" type="registration" :platform="platform" :prices="prices" v-if="type === 'create'"></field-payment>

                <div v-if="!canEdit && platform === 'marketplace' && (item.invited_by_name || item.registered_by_name )" class="form-line" >
                    <div class="form-field" style="width: 100%">
                        <label>Gift Order Made by</label>
                        <div v-if="item.invited_by_name" class="form-static-field">{{ item.invited_by_name }}</div>
                        <div v-else class="form-static-field">{{ item.registered_by_name }}</div>
                    </div>
                </div>
                
                <div v-if="platform === 'marketplace' && this.demo.isDemo" class="demo-note">
                    <h4><span>Leave preview mode:</span> Would you like to send a gift like this now?</h4>
                    <p>Click below to leave the preview mode and sign up for a free <i>On Demand</i> account to send unlimited Bookblock HUB Marketplace gifts.</p>
                    <div class="ws-button ws-button-white" @click="modals.registrationModal = true">Sign Up To Bookblock HUB</div>
                </div>
                
                
            </div>
            
            <div class="modal-errors">
                <p v-for="e in errors" class="form-field error-text">{{ e[0] }}</p>
            </div>                  
        </form>
        
        <div class="form-actions">
            <div v-if="type === 'create'" class="ws-button ws-button-secondary" data-action="cancel" @click="modals.giftRegistrationModal = false">Cancel</div>
            <div v-if="type === 'create' && step!=='start'" class="ws-button" data-action="continue" @click="previousStep">Go Back</div>
            <div v-if="type === 'create' && step!=='summary'" class="ws-button ws-button-main" data-action="continue" @click="nextStep">Continue</div>
            <div v-if="type === 'create' && step=='summary' && userCanCheckout" class="ws-button ws-button-main" data-action="submit" @click="submit">Send the gift</div>
            
            <div v-if="type === 'edit'" class="ws-button ws-button-secondary" data-action="cancel" @click="modals.giftRegistrationModalEdit = false">Close</div>
            <div v-if="type === 'edit' && canEdit" class="ws-button ws-button-main" @click="submit">Update Gift Registration</div>
        </div>
      </div>
      
      <!-- Payment Processing -->
      <div v-else-if="screen === 'payment'">
          <div class="ws-form-processing"><div class="value-loader"></div><p>We are processing your payment. <br>Please give us a moment...</p></div>
      </div>
      
      <!-- Order Prgcessing -->
      <div v-else-if="screen === 'processing'">
          <div class="ws-form-processing"><div class="value-loader"></div><p>We are processing your gift registration. <br>Please give us a moment...</p></div>
      </div>
      
      <!-- Loading -->
      <div v-else-if="screen === 'loading'">
          <div class="ws-form-processing"><div class="value-loader"></div><p><span v-if="this.registrationId">We're retrieving your gift registration.</span><span v-else>We're verifying your gift option availability.</span> <br>Please give us a moment...</p></div>
      </div>
      
  </modal>
</template>

<script>
import Modal from "@/components/modals/Modal";
import FieldNotecard from "@/components/FieldNotecard";
import PaymentSummaryTable from "@/components/PaymentSummaryTable";
import FieldPayment from "@/components/FieldPayment";

export default {
    name: "GiftRegistrationModal",
    components: {Modal,FieldNotecard,PaymentSummaryTable,FieldPayment},
    props: {
        campaignId: Number,
        productId: Number,
        voucherBrand: String,
        registrationId: Number,
        fetchItem: {type: Boolean, default: false},
        type: {type: String, default: 'create'},
        platform: {type: String, default: 'gifting'},
    },
    data() {
        return {
            screen: 'loading',
            step: 'start',
            physicalSteps: ['start','address','notecard','summary'],
            digitalSteps: ['start','summary'],            
            item: {type: null, platform: null, email: null, first_name: null, last_name: null, address_line_1: null,
                address_line_2: null, city: null, region: null, postcode: null, country: 'GB', phone:null, option_id: 0, quantity: 1, notecard_text: '', registered_by: null, notecard_type: 'none', send_email: false, custom_email_message: false, invitation_message: '', payment_method: 'team-balance', payment_method_id: null, voucher_value: 0},
            registration: null,
            prices: {prepaid: 0, gift: 0, notecard: 0, admin: 0, shipping: 0, voucher: 0, total: 0},
            pricesExVat: {prepaid: 0, gift: 0, notecard: 0, admin: 0, shipping: 0, voucher: 0, total: 0},
            option: {},
            errors: {},
            shippingCountryMismatch: false,
            canEdit: false,
            rejected: false,
            defaultVoucherLimits: {lower: 2, upper: 500, minor_unit: 0.01},
            voucherLimits: {lower: 2, upper: 500, minor_unit: 0.01},
            voucherDenominations: [],
            shippingCountries: {},
        }
    },
    methods: {
        nextStep() {
            if (this.step == 'summary') return;
            let steps = this.physicalSteps;
            if (this.item.type=='voucher') steps = this.digitalSteps;
            for (let i = 0; i!=steps.length; i++) if (steps[i]==this.step) {
                if (this.verifyStep(this.step)) this.goToStep(steps[i+1]);
                break;
            }
        },
        previousStep() {
            if (this.step == 'start') return;
            let steps = this.physicalSteps;
            if (this.item.type=='voucher') steps = this.digitalSteps;
            for (let i = 0; i!=steps.length; i++) if (steps[i]==this.step) {
                this.goToStep(steps[i-1]);
                break;
            }
        },
        verifyStep(step) {
            let rules = [];
            if (step == 'start') {
                if (this.platform == 'gifting') {
                    rules = rules.concat([
                        { name: 'Gift Option', value: this.item.option_id, rules: ['required'] },       
                    ]);
                }
                
                rules = rules.concat([
                    { name: 'Email', value: this.item.email, rules: ['required', 'minLength:1'] },
                    { name: 'First Name', value: this.item.first_name, rules: ['required', 'minLength:1'] },
                    { name: 'Last Name', value: this.item.last_name, rules: ['required', 'minLength:1'] },                
                ]);
                
                if (this.item.type == 'voucher') {
                  rules = rules.concat([
                    { name: 'Voucher Value', value: this.item.voucher_value, rules: ['required', 'posFloat', 'minValue:'+this.voucherLimits.lower, 'maxValue:'+this.voucherLimits.upper] },
                  ]);
                }
            }
            
            if (step == 'address') {
                rules = rules.concat([
                  { name: 'Address line 1', value: this.item.address_line_1, rules: ['required', 'minLength:1'] },
                  { name: 'City', value: this.item.city, rules: ['required', 'minLength:1'] },
                  { name: 'Postcode', value: this.item.postcode, rules: ['required', 'minLength:1'] },
                  { name: 'Country', value: this.item.country, rules: ['required', 'minLength:1'] },
                ]);
                
                if (this.item.country !== 'GB') {
                    rules.push({ name: 'Phone', value: this.item.phone, rules: ['required'] });
                }
            }
            
            this.errors = this.validateFields(rules);
            if (step == 'address' && this.shippingCountryMismatch) {
                if (typeof this.errors['Country'] === 'undefined') this.errors['Country'] = [];
                this.errors['Country'].push('We do not currently ship this gift to this country.');
            }
            if (Object.keys(this.errors).length) {
                return false;
            }
            else return true;
        },
        goToStep(step) {
            this.step = step;
        },
        async submitCreate() {  
            if (!this.demoCheck()) return;
                      
            if (this.prices.total!==0) {
                this.screen = 'payment'; 
                try {
                    if (this.item.payment_method == 'stripe') {
                        let descDetail = '';
                        if (this.platform=='marketplace' && this.item.product_id) descDetail = 'Product ID: #'+this.item.product_id;
                        else if (this.platform=='marketplace' && this.item.voucher_brand) descDetail = 'Voucher Brand: '+this.item.voucher_brand;
                        else if (this.item.option_id) descDetail = 'Option ID: #'+this.item.option_id;
                        
                        await this.dispatchWaitAndNotify('postStripePaymentIntent', {
                            'payment_method_id': this.item.payment_method_id,
                            'amount': this.prices.total,
                            'description': 'Bookblock HUB Pro '+this.platform.toUpperCase()+' Direct Send ('+descDetail+')',
                            'suffix': (this.platfom=='marketplace')?'market':'gifting',
                        }, false, true);
                        this.item.payment_id = this.paymentIntentResult.payment_intent_id;
                    } else {
                        await this.dispatchWaitAndNotify('checkTeamBalance', this.prices.total, false, true);
                    }
                } catch (e) {
                    this.screen = 'form';
                    return;
                }
            }
            
            this.screen = 'processing';
            this.item.action = 'confirm';
            
            if (this.item.send_email == 'true') this.item.send_email = true;
            if (this.item.send_email == 'false') this.item.send_email = false;            
            if (this.item.notecard_type!='custom') this.item.notecard_text = '';              
                  
            try {
              if (this.platform == 'gifting') await this.dispatchWaitAndNotify('createGiftBoxCampaignRegistration', {campaignId: this.campaign.id, payload: this.item});
              if (this.platform == 'marketplace') await this.dispatchWaitAndNotify('createGiftBoxRegistration', {payload: this.item});
              this.screen='form';
              this.$emit('created');
            } catch (e) {
                this.screen = 'form';
            }            
        },
        async submitEdit() {
            if (!this.demoCheck()) return;
            
            var rules = [];
            if (!this.item.option_id) {
                rules = [
                    { name: 'Email', value: this.item.email, rules: ['required', 'minLength:1'] },             
                ];
                delete this.item.option_id;
            }
            
            else {
                rules = [
                    { name: 'First Name', value: this.item.first_name, rules: ['required', 'minLength:1'] },
                    { name: 'Last Name', value: this.item.last_name, rules: ['required', 'minLength:1'] },
                    { name: 'Email', value: this.item.email, rules: ['required', 'minLength:1'] },
                    { name: 'Gift Option', value: this.item.option_id, rules: ['required'] },
                    { name: 'Quantity', value: this.item.quantity, rules: ['required', 'N'] },
                ];
                
                if (this.canEditAddress) {
                    rules = rules.concat([
                            { name: 'Address line 1', value: this.item.address_line_1, rules: ['required', 'minLength:1'] },
                            { name: 'City', value: this.item.city, rules: ['required', 'minLength:1'] },
                            { name: 'Postcode', value: this.item.postcode, rules: ['required', 'minLength:1'] },
                            { name: 'Country', value: this.item.country, rules: ['required', 'minLength:1'] }]
                        );
                    if (this.item.country !== 'GB') {
                        rules.push({ name: 'Phone', value: this.item.phone, rules: ['required'] });
                    }
                }
            } 
            
            if (!this.canEditAddress || !this.item.option_id) {
                delete this.item.address_line_1;
                delete this.item.address_line_2;
                delete this.item.city;
                delete this.item.region;
                delete this.item.postcode;
                delete this.item.country;
                delete this.item.phone;
            } 
            this.errors = this.validateFields(rules);
            if (Object.keys(this.errors).length) {
              return;
            }
            
            this.item.action = 'edit';
            this.screen = 'processing';
            try {
                await this.dispatchWaitAndNotify('updateGiftBoxRegistration', {registrationId: this.registrationId, payload: this.item});
                this.screen='form';
                this.$emit('created');
            } catch (e) {
                this.screen = 'form';
            }       
        },
        submit() {
            if (this.type === 'create') {
                this.submitCreate();
            } else if (this.type === 'edit') {
                this.submitEdit();
            }
        },
        close() {
            if (this.type === 'create') {
                this.modals.giftRegistrationModal = false
            } else if (this.type === 'edit') {
                this.modals.giftRegistrationModalEdit = false
            }
        },
        onOptionChange() {      
          if (!this.campaign || !this.campaign.options) return; 
          
          //this.item.type = null;
          this.option = null;
          for (let i = 0; i!=this.campaign.options.length; i++) {
            if (this.campaign.options[i].id==this.item.option_id) {
              this.option = this.campaign.options[i];
              if (this.type != 'create') continue;
              
              this.item.type = this.campaign.options[i].type;
              this.updatePrice('admin',{ev: this.option.pp_ev_cost, iv: this.option.pp_iv_cost});
              
              if (this.item.type == 'voucher') {
                this.item.voucher_value = this.campaign.options[i].voucher_value;
                
                if (this.campaign.options[i].voucher_brand_info && this.campaign.options[i].voucher_brand_info.digital_denominations) {
                    this.voucherDenominations = this.campaign.options[i].voucher_brand_info.digital_denominations;
                    //this.item.voucher_value = this.voucherDenominations[0];
                    this.voucherLimits = this.defaultVoucherLimits;
                } else if (this.campaign.options[i].voucher_brand_info && this.campaign.options[i].voucher_brand_info.digital_face_value_limits) {
                    this.voucherDenominations = [];
                    let brandLimits = this.campaign.options[i].voucher_brand_info.digital_face_value_limits;
                    
                    if (brandLimits.lower > this.defaultVoucherLimits.lower) this.voucherLimits.lower = brandLimits.lower;
                    else this.voucherLimits.lower = this.defaultVoucherLimits.lower;
                    
                    if (brandLimits.upper < this.defaultVoucherLimits.upper) this.voucherLimits.upper = brandLimits.upper;
                    else this.voucherLimits.upper = this.defaultVoucherLimits.upper;
                    
                    if (brandLimits.minor_unit != this.defaultVoucherLimits.minor_unit) this.voucherLimits.minor_unit = brandLimits.minor_unit;
                    else this.voucherLimits.minor_unit = this.defaultVoucherLimits.minor_unit;
                } else {
                    this.voucherDenominations = [];
                    this.voucherLimits = this.defaultVoucherLimits;
                }
              }
            }
          }
        },
        getShippingCosts() {
            if (this.type=='edit' && this.registration && !this.canEdit) {
                return {ev: this.registration.shipping_ev_cost, iv: this.registration.shipping_iv_cost};
            }
            
            if (!this.option) return 0;
            if (!this.option.shipping_costs) return 0;
            if (!this.item.country) return 0;
            this.shippingCountryMismatch = false;
            let zone = Object.values(this.option.shipping_costs).find(x => x.countries.includes(this.item.country));
            if (zone) {
                return {ev: zone.shipping_ev_cost, iv: zone.shipping_iv_cost};
            }
            this.shippingCountryMismatch = true;
            return 0;
        },
        updateShippingCountries() {
            if (!this.option || !this.option.shipping_costs) return;
            
            let allowedCountries = Object.keys(this.option.shipping_costs).reduce((a, v) => ([...a, ...this.option.shipping_costs[v].countries]), []);
            this.shippingCountries = [];
            for (let i = 0; i < this.isoCountries.length; i++) {
                if (allowedCountries.includes(this.isoCountries[i].value)) this.shippingCountries.push(this.isoCountries[i]);
            }
        },
        updatePrice(type,price = null) {
            // calculate price if not set
            if (price === null) {
                price = { ev: 0, iv: 0 };
                if (type == 'notecard') {
                    if (this.item.notecard_type=='default' || (this.item.notecard_type=='custom' && this.item.notecard_text!='')) {
                        price.ev = this.$store.state.notecard_price_exc_vat;
                        price.iv = this.$store.state.notecard_price;
                    }                    
                }
                if (type == 'shipping') {
                    price = this.getShippingCosts();
                }
            }
            
            //console.trace();
            //console.log(type + ' - ' + price.iv + ' / ' + price.ev);
            
            if (typeof price.iv !== 'undefined') this.prices[type] = parseFloat(price.iv);
            if (typeof price.ev !== 'undefined') this.pricesExVat[type] = parseFloat(price.ev);
            
            if (this.item.quantity > 1 && ['shipping','admin'].includes(type)) {
                this.prices[type] = this.prices[type] * this.item.quantity;
                this.pricesExVat[type] = this.pricesExVat[type] * this.item.quantity;
            }            
            if (this.item.type=='physical') {
                this.prices.total = this.prices.gift + this.prices.notecard + this.prices.admin + this.prices.shipping;
                this.pricesExVat.total = this.pricesExVat.gift + this.pricesExVat.notecard + this.pricesExVat.admin + this.pricesExVat.shipping;
            }
            if (this.item.type=='voucher') {
                this.prices.total = this.prices.voucher + this.prices.admin;
                this.pricesExVat.total = this.pricesExVat.voucher + this.pricesExVat.admin;
            }
        },
        optionName(id,options) {
          for (let i = 0; i!=options.length; i++) if (options[i].id==id) return options[i].name;
        },
        countryName(code) {
          const result = this.isoCountries.filter(country => country.value === code);
          if (result.length) return result[0].text;
          else return code;
        },
        
    },
    async mounted() {
        if (this.platform !== 'marketplace' && !this.proCheck('Adding gift registrations')) {
            this.modals.giftRegistrationModal = false;
            return;
        }
        
        if (this.fetchItem && this.campaignId) await this.dispatchWaitAndNotify('fetchGiftBoxCampaign', {campaignId: this.campaignId}, false, true);
        if (this.productId) {
            this.option = await this.dispatchWaitAndNotify('fetchMarketplaceProduct', {productId: this.productId}, false, true);
            this.item.type = this.option.type;
            this.item.product_id = parseInt(this.productId);
        } else if (this.voucherBrand) {
            this.option = await this.dispatchWaitAndNotify('fetchMarketplaceDigitalProduct', this.voucherBrand, false, true);
            this.item.type = this.option.type;
            this.item.voucher_brand = this.option.slug;
            this.item.voucher_value = 10;
            this.updatePrice('admin',{ev: 1, iv: 1.2});
            
            if (this.option.face_value_limits) {
                this.voucherLimits = this.option.face_value_limits;
                if (this.option.face_value_limits.lower > this.item.voucher_value) this.item.voucher_value = this.option.face_value_limits.lower;
            } else if (this.option.denominations) {
                this.voucherDenominations = this.option.denominations;
                this.item.voucher_value = this.option.denominations[0];
            }
        }
        this.item.platform = this.platform;
        
        if (this.campaign.reward_type == 'physical') this.item.type = 'physical';
        if (this.campaign.reward_type == 'voucher') this.item.type = 'voucher';
        
        if (this.type === 'edit') {
            // Edit / View Details
            this.registration = await this.dispatchWaitAndNotify('fetchGiftBoxRegistration', {registrationId: this.registrationId}, false, true);
            this.item.type = this.registration.type;
            this.item.option_id = parseInt(this.registration.option_id);
            if (!this.item.option_id) this.item.option_id = null;
            this.item.quantity = parseInt(this.registration.quantity);
            
            this.item.email = this.registration.email;
            this.item.first_name = this.registration.first_name;
            this.item.last_name = this.registration.last_name;
            this.item.country = this.registration.country;
            this.item.registered_by = this.registration.registered_by;  
            this.item.payment_method = this.registration.payment_method;
            this.item.invited_by_name = this.registration.invited_by_name;  
            this.item.registered_by_name = this.registration.registered_by_name;  
            
            this.updatePrice('admin',{ev: this.registration.pp_ev_cost?this.registration.pp_ev_cost:0, iv: this.registration.pp_iv_cost?this.registration.pp_iv_cost:0});
            
            if (this.item.type=='voucher') {
                // Digital Gifts
                this.item.voucher_url = this.registration.voucher_url;
                this.item.voucher_value = this.registration.voucher_value;
                this.item.voucher_brand_name = this.registration.voucher_brand_name;
                
                this.updatePrice('voucher',{ev: this.registration.voucher_value, iv: this.registration.voucher_value});
            } else {
                // Physical gifts
                this.item.address_line_1 = this.registration.address_line_1;
                this.item.address_line_2 = this.registration.address_line_2;
                this.item.city = this.registration.city;
                this.item.region = this.registration.region;
                this.item.postcode = this.registration.postcode;
                this.item.phone = this.registration.phone;
                this.item.notecard_type = this.registration.notecard_type;
                this.item.notecard_text = this.registration.notecard_text;
                
                if (this.registration.transactions && this.registration.transactions.length) {
                    const prepaidGiftTransactions = this.registration.transactions.filter(({ type }) => type === 'prepaid-gift');
                    if (prepaidGiftTransactions) {
                        const prepaidGiftTransaction = prepaidGiftTransactions.reduce((n, {price}) => n + parseFloat(price), 0);
                        if (prepaidGiftTransaction) this.updatePrice('prepaid',{iv: prepaidGiftTransaction.price, ev: prepaidGiftTransaction.price_ex_vat});
                    }
                    
                    const mpGiftTransactions = this.registration.transactions.filter(({ type }) => type === 'marketplace');
                    if (mpGiftTransactions) {
                        const mpGiftTransaction = mpGiftTransactions.reduce((n, {price}) => n + parseFloat(price), 0);
                        if (mpGiftTransaction) this.updatePrice('gift',{iv: mpGiftTransaction.price, ev: mpGiftTransaction.price_ex_vat});
                    }
                }

                this.updatePrice('notecard');
                this.updatePrice('shipping',{ev: this.item.shipping_ev_cost, iv: this.item.shipping_iv_cost});
            }
            if (this.platform === 'marketplace') this.canEdit = false;
            else if (this.registration.processed_at || this.registration.rejected_at) this.canEdit = false;
            else this.canEdit = true;
                    
            if (this.registration.rejected_at) this.rejected = true;
            
            if (this.platform === 'gifting') this.onOptionChange();
            
        } else {
            // Create New Registration
            this.canEdit = true;
            if (!this.campaign.notecard_text) this.item.notecard_type = 'none';
            if (this.item.notecard_type=='none') this.updatePrice('notecard',{ev: 0, iv: 0});
            else this.updatePrice('notecard',{ev: this.$store.state.notecard_price_exc_vat, iv: this.$store.state.notecard_price});
            this.item.send_email = true;
            
            if (this.platform=='gifting') this.shippingCountries = this.isoCountries;
            else if (this.platform=='marketplace') this.shippingCountries = [{value: 'GB', text: 'United Kingdom'}];
        }
        
        
        this.screen = 'form';
    },
    computed: {
        user() {
            return this.$store.state.currentUser;
        },
        userCanCheckout() {
            return this.user.permissions && (this.user.permissions.includes('use-balance') || this.user.permissions.includes('use-cards')) && (this.item.payment_method=='team-balance' || this.item.payment_method_id);
        },
        campaign() {
            return this.$store.state.giftBoxCampaign.detail;
        },
        modals() {
            return this.$store.state.modals;
        },
        isoCountries() {
            return this.$store.state.isoCountries;
        },
        boxOptions() {
            return this.campaign.options.map(i => ({text:i.name, value:i.id}));
        },
        canEditAddress() {
            return (this.type === 'create' || !parseInt(this.registration.option_id) || (this.item.registered_by && (this.item.registered_by == this.$store.state.currentUser.user_id) && this.canEdit));
        },
        canEditPricing() {
            return (this.item.payment_method == 'team-balance' && this.canEdit );
        },
        paymentIntentResult() {
            return this.$store.state.transaction.paymentIntentResult;
        },
        demo() {
            return this.$store.state.demo;
        }
    },
    watch: {
        'option.price': {
			handler (value) {
				if (this.platform == 'gifting') {
                    this.updatePrice('prepaid',{iv: value});
                    this.updatePrice('gift',{iv: 0});
                } else if (this.platform == 'marketplace') {
                    this.updatePrice('prepaid',{iv: 0});
                    this.updatePrice('gift',{iv: value});
                }
			},
		},
        'option.price_ex_vat': {
			handler (value) {
				if (this.platform == 'gifting') {
                    this.updatePrice('prepaid',{ev: value});
                    this.updatePrice('gift',{ev: 0});
                } else if (this.platform == 'marketplace') {
                    this.updatePrice('prepaid',{ev: 0});
                    this.updatePrice('gift',{ev: value});
                }
			},
		},
        'option.shipping': {
            handler (value) {
                this.updateShippingCountries();
                this.updatePrice('shipping',{iv: value});
			},
        },
        'option.shipping_ex_vat': {
            handler (value) {
                this.updateShippingCountries();
                this.updatePrice('shipping',{ev: value});
			},
        },
        'option.shipping_costs': {
            handler (value) {
                this.updateShippingCountries();
                this.updatePrice('shipping');
			},
        },
        'item.quantity': {
			handler (value) {
                this.updatePrice('shipping');
				if (this.type == 'create') this.updatePrice('admin',{ev: this.option.pp_ev_cost, iv: this.option.pp_iv_cost});
			},
		},
        'item.country': {
            handler (value) {
                this.updatePrice('shipping');
			},
        },
		'item.voucher_value': {
			handler (value) {
				this.updatePrice('voucher',{ev: value, iv: value});
			},
		},
        'item.option_id': {
			handler (value) {
                this.updatePrice('notecard');
			},
		},
        'item.notecard_type': {
			handler (value) {
                this.updatePrice('notecard');
			},
		},
        'item.notecard_text': {
			handler (value) {
                this.updatePrice('notecard');
			},
		}
	}
}
</script>

<style scoped>

</style>